<template>
  <div class="myOrder comBag" >
    <div class="personal-box comWidth">
    <CenterNav/>
    <div class="personal-right">
      <el-tabs v-model="activeName" >
        <el-tab-pane  label="所有訂單" name="first">
          <span slot="label"> 所有訂單 <span class="num">{{ num_a }}</span></span>
          <TabData :orders="allOrders" :total="total_a" :pageSize="pageSize_a" @pagingS="paging_a" @allList="allList" />
        </el-tab-pane>
        <el-tab-pane label="待付款" name="second">
          <span slot="label"> 待付款 <span class="num">{{ num_b }}</span></span>
          <TabData :orders="pendingPayment" :total="total_b" :pageSize="pageSize_b" @pagingS="paging_b" @allList= "allList" />
        </el-tab-pane>
        <el-tab-pane label="待發貨" name="third">
          <span slot="label"> 待發貨 <span class="num">{{ num_c }}</span></span>
          <TabData :orders="pendingDelivery" :total="total_c" :pageSize="pageSize_c" @pagingS="paging_c"/>
        </el-tab-pane>
        <el-tab-pane label="待收貨" name="fourth">
          <span slot="label"> 待收貨 <span class="num">{{ num_d }}</span></span>
          <TabData :orders="goodsReceived" :total="total_d" :pageSize="pageSize_d" @allList="allList" @pagingS="paging_d"/>
        </el-tab-pane>
        <el-tab-pane label="已收貨" name="five">
          <span slot="label"> 已收貨 <span class="num">{{ num_e }}</span></span>
          <TabData :orders="haveReceivedGoods" :total="total_e" :pageSize="pageSize_e" @pagingS="paging_e"/>
        </el-tab-pane>
      </el-tabs>

    </div>
    </div>
  </div>
</template>

<script>
  //tab
  import TabData from '@/pages/personalPage/orderCenter/TabData'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  //api
  import {orderList ,orderPage} from '@/api/order';
  //common.js
  import {getLocalStorage,setLocalStorage , ifSignIn} from '@/utils/common';
  export default {
    name: 'MyOrder',
    components:{
      CenterNav,
      TabData
    },
    data () {
      return {

        activeName: 'first',
        //所有订单
        allOrders:[],
        allState:{
          page:1,
          order_status:undefined,
          pay_status:undefined,
          deliver_status:undefined
        },
        num_a:'',
        total_a:0,//总页数
        pageSize_a:0,//每页显示个数
        //待付款
        pendingPayment:[],
        payState:{
          page:1,
          order_status:0,
          pay_status:0,
          deliver_status:0,
        },
        num_b:0,
        total_b:0,//总页数
        pageSize_b:0,//每页显示个数
        //待发货
        pendingDelivery:[],
        deState:{
          page:1,
          pay_status:1,
          deliver_status:1,
        },
        num_c:0,
        total_c:0,//总页数
        pageSize_c:0,//每页显示个数
        //待收货
        goodsReceived:[],
        reState:{
          page:1,
          deliver_status:2,
          pay_status:1,
          order_status:1,
        },
        num_d:0,
        total_d:0,//总页数
        pageSize_d:0,//每页显示个数
        //已收货
        haveReceivedGoods:[],
        goState:{
          page:1,
          order_status:2,
          pay_status:1,
          deliver_status:2,
        },
        num_e:0,
        total_e:0,//总页数
        pageSize_e:0,//每页显示个数

        //支付方式
        orderMsg:{}
      }
    },
    methods:{
        /*全部订单*/
      goodsOrderList(val){
        this.allState.page = val
        orderList(this.allState).then(res =>{
            this.allOrders = res.data.data;
            this.num_a = res.data.meta.pagination.total;
            this.total_a = res.data.meta.pagination.total;
            this.pageSize_a = res.data.meta.pagination.per_page;
           this.orderMsg = res.data.meta.payment_method;
//          sessionStorage.removeItem('orderMsg')
           setLocalStorage('orderMsg' , res.data.meta.payment_method);
        });
      },

      /*待付款订单*/
      paymentOrder(val){
        this.payState.page = val
        orderList(this.payState).then(res =>{
          this.pendingPayment = res.data.data;
          this.num_b = res.data.meta.pagination.total;
          this.total_b = res.data.meta.pagination.total;
          this.pageSize_b = res.data.meta.pagination.per_page;
        })
      },

      /*待发货订单*/
      deliveryOrder(val){
        this.deState.page = val
        orderList(this.deState).then(res =>{
          this.pendingDelivery = res.data.data;
          this.num_c = res.data.meta.pagination.total;
          this.total_c = res.data.meta.pagination.total;
          this.pageSize_c = res.data.meta.pagination.per_page;
        })
      },

      /*待收货订单*/
      ordersReceived(val){
        this.reState.page = val
        orderList(this.reState).then(res =>{
          this.goodsReceived = res.data.data;
          this.num_d = res.data.meta.pagination.total;

          this.total_d = res.data.meta.pagination.total;
          this.pageSize_d = res.data.meta.pagination.per_page;
        })
      },

      /*已收货订单*/
      orderReceipt(val){
        this.goState.page = val
        orderList(this.goState).then(res =>{
          this.haveReceivedGoods = res.data.data;
          this.num_e = res.data.meta.pagination.total;
          this.total_e = res.data.meta.pagination.total;
          this.pageSize_e = res.data.meta.pagination.per_page;
        })
      },

      /*分页*/
      paging_a(page){
        this.goodsOrderList(page);
      },
      paging_b(page){
        this.paymentOrder(page);
      },
      paging_c(page){
        this.deliveryOrder(page);
      },
      paging_d(page){
        this.ordersReceived(page);
      },
      paging_e(page){
        this.orderReceipt(page);
      },
      /*所有数据*/
      allList(){
        //全部订单
        this.goodsOrderList(1);
        //待付款订单
        this.paymentOrder(1);
        //待发货
        this.deliveryOrder(1);
        //待收货订单
        this.ordersReceived(1);
        //已收货订单
        this.orderReceipt(1);
      }
    },
    created(){
       //全部订单
       this.goodsOrderList(1);
       //待付款订单
       this.paymentOrder(1);
       //待发货订单
       this.deliveryOrder(1);
       //待收货订单
       this.ordersReceived(1);
       //已收货订单
       this.orderReceipt(1);
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/personalPage/orderCenter/MyOrder.vue